const phoneWithoutSpaces = (value: string): string => value.trim().replace(/\p{Zs}+/gu, '')

export const normalizePhone = (value: string | null | undefined): string => {
    const phone = phoneWithoutSpaces(value ?? '')
    return phone.startsWith('0') && !phone.startsWith('00') ? `+359${phone.slice(1)}` : phone
}

export const isValidPhone = (value: string | null | undefined): boolean => {
    const phone = normalizePhone(value)
    return !phone || /^\+[1-9][0-9]{7,14}$/.test(phone)
}

export const phoneValidator = (_rule: unknown, value: string | null | undefined, callback: (error?: Error) => void) => {
    callback(isValidPhone(value) ? undefined : new Error('Format: 0876109586 / +359876109586'))
}

export const localDateFormat=(date:string|null|undefined)=>{
    if (!date) return '';
  const locale = typeof document === 'undefined' ? 'bg' : document.documentElement.lang || 'bg';
  return new Date(date).toLocaleDateString(locale)
}
